import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import DateTime from '_class/DateTime';
import PostContent from 'components/Presentation/PostContent';
import { Spinner, Collapsible } from 'UI';
import { Editor } from 'UI/Inputs';
import { Flex, Button, translate } from '@haldor/ui';
import './EditStudentAdjustmentForm.scss';

var EditStudentAdjustmentForm = /*#__PURE__*/function (_Component) {
  _inherits(EditStudentAdjustmentForm, _Component);

  var _super = _createSuper(EditStudentAdjustmentForm);

  function EditStudentAdjustmentForm() {
    var _this;

    _classCallCheck(this, EditStudentAdjustmentForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit != null) {
          // Clean up properties that doesnt need to be sent to the api
          delete values.comments;
          delete values.createdBy;
          delete values.editedBy;
          delete values.versions;
          delete values.student;

          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cancel", function (event) {
      event.preventDefault();

      if (_this.props.onClose != null) {
        _this.props.onClose();
      }
    });

    return _this;
  }

  _createClass(EditStudentAdjustmentForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;

      if (this.props.adjustment == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container additional-adjustments edit-student-adjustment"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('description'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "description"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.cancel
      }, this.props.translate('Cancel'))))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '3rem'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('previous-versions')
      }, this.props.adjustment.versions != null ? this.props.adjustment.versions.map(function (version) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '0.25rem 0',
            paddingLeft: 26,
            marginBottom: '.95rem'
          },
          key: version.id
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            fontWeight: 500,
            fontSize: '1.12rem'
          }
        }, version.additionalAdjustment.title), /*#__PURE__*/React.createElement("p", {
          style: {
            marginTop: '0.5rem'
          }
        }, /*#__PURE__*/React.createElement(PostContent, null, version.description)), /*#__PURE__*/React.createElement("div", {
          className: "createdBy color--meta"
        }, version.createdBy.firstName, " ", version.createdBy.lastName, ' • ' + new DateTime(version.created).getShortDate(true)));
      }) : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Template')
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0.25rem 0',
          paddingLeft: 26
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 500,
          fontSize: '1.12rem'
        }
      }, this.props.adjustment.additionalAdjustment.title), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '0.5rem'
        }
      }, /*#__PURE__*/React.createElement(PostContent, null, this.props.adjustment.additionalAdjustment.description)), /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, this.props.adjustment.additionalAdjustment.createdBy.firstName, " ", this.props.adjustment.additionalAdjustment.createdBy.lastName, ' • ' + new DateTime(this.props.adjustment.created).getShortDate(true))))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }));
    }
  }]);

  return EditStudentAdjustmentForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    initialValues: JSON.parse(JSON.stringify(ownProps.adjustment))
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'EditStudentAdjustmentForm',
  destroyOnUnmount: true
})(EditStudentAdjustmentForm));